import { Injectable, inject } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { EmailTemplate, EmailTemplateDocId } from '../models/email-template.model';
import { FirebaseAwareService } from '../shared/firestore/firebase-aware.service';

@Injectable({ providedIn: 'root' })
export class EmailTemplateAdminService extends FirebaseAwareService {
  private readonly functions = inject(Functions);

  listTemplates(): Promise<EmailTemplate[]> {
    const call = this.inCtx(() =>
      httpsCallable<void, { templates: EmailTemplate[] }>(
        this.functions,
        'listEmailTemplatesAdmin',
      ),
    );
    return call().then(r => r.data.templates);
  }

  getTemplate(docId: EmailTemplateDocId): Promise<EmailTemplate> {
    return this.listTemplates().then(templates => {
      const found = templates.find(t => t.stateId === docId);
      if (!found) throw new Error(`Template not found: ${docId}`);
      return found;
    });
  }

  updateTemplate(
    docId: EmailTemplateDocId,
    subject: string,
    bodyHtml: string,
    options?: { bodyText?: string; enabled?: boolean },
  ): Promise<EmailTemplate> {
    const call = this.inCtx(() =>
      httpsCallable<
        { docId: string; subject: string; bodyHtml: string; bodyText?: string; enabled?: boolean },
        { template: EmailTemplate }
      >(this.functions, 'updateEmailTemplateAdmin'),
    );
    return call({ docId, subject, bodyHtml, ...options }).then(r => r.data.template);
  }

  seedDefaults(
    overwrite = false,
    docIds?: EmailTemplateDocId[],
  ): Promise<{ templates: EmailTemplate[]; written: number; skipped: number }> {
    const call = this.inCtx(() =>
      httpsCallable<
        { overwrite?: boolean; docIds?: EmailTemplateDocId[] },
        { templates: EmailTemplate[]; written: number; skipped: number }
      >(this.functions, 'seedEmailTemplatesAdmin'),
    );
    return call({ overwrite, docIds }).then(r => r.data);
  }

}
